import React from 'react';
import HelpApiLayout from '../../../../components/layout/HelpApiLayout';
import HelpSidebar from '../../../../components/layout/HelpSidebar';
import ArticleViewer from '../../components/ArticleViewer';
import { PUBLIC_ROUTES } from '../../../../constants/routes';
import '../getting-started/HelpCategoryPage.css';

/**
 * Payment Problems Article Page
 */
const PaymentProblems = () => {
  return (
    <HelpApiLayout type="help" sidebar={<HelpSidebar />}>
      <div className="help-category-page">
        <div className="help-category-container">
          <main className="help-category-main">
            <ArticleViewer 
              title="Payment Problems"
              showQA={true}
              articleId="payment-problems"
            >
              <div className="article-content">
                <p>
                  Having trouble with payments? Here are common payment issues and how to resolve them.
                </p>
                
                <h2>Payment Declined</h2>
                <p><strong>Possible causes and solutions:</strong></p>
                <ul>
                  <li><strong>Insufficient funds:</strong> Check your account balance</li>
                  <li><strong>Card expired:</strong> Update your payment method</li>
                  <li><strong>Bank security:</strong> Contact your bank to approve the transaction</li>
                  <li><strong>Daily limit:</strong> Wait 24 hours or contact support to increase limit</li>
                </ul>

                <h2>Payment Stuck in Pending</h2>
                <p>
                  Some payment methods take time to process. Bank transfers typically take 1-3
                  business days. If your payment is pending longer than expected:
                </p>
                <ul>
                  <li>Check your bank statement for the transaction</li>
                  <li>Contact your bank to verify the transfer status</li>
                  <li>Reach out to WeSplit support with the transaction ID</li>
                </ul>

                <h2>Wrong Amount Charged</h2>
                <p>
                  If you were charged an incorrect amount:
                </p>
                <ul>
                  <li>Check the split details to verify the correct amount</li>
                  <li>Review your transaction history</li>
                  <li>Contact support immediately with transaction details</li>
                </ul>

                <h2>Can't Add Payment Method</h2>
                <p><strong>Try these steps:</strong></p>
                <ul>
                  <li>Verify your payment information is correct</li>
                  <li>Check that your payment method is supported in your region</li>
                  <li>Ensure you have a stable internet connection</li>
                  <li>Try a different payment method</li>
                </ul>
              </div>
            </ArticleViewer>
          </main>
        </div>
      </div>
    </HelpApiLayout>
  );
};

export default PaymentProblems;
